import { Measurement_Audit_Log, GT_Measurement, Measurement_Meta } from '../../types/measurement'
import ClickEvent = JQuery.ClickEvent
import { Toast } from '@app/utils/toast'
import { Measurement_Document } from '../../types/projects'
type Measurement_Meta_Key = keyof Measurement_Meta;
export abstract class Measurement_Controller {}

export function create_measurement_file_input( container: HTMLElement, id: number ) {
    const file = document.createElement( 'div' )

    file.classList.add( 'inline', 'fields', 'measurement-document-fields' )
    file.innerHTML = `
		<div class="six wide field">
			<div class="ui labeled input">
				<label for="measurement-document-titles[${id}]" class="ui label"></label>
				<input type="text" class="form-control" name="measurement-document-titles[${id}]" id="measurement-document-titles[${id}]" placeholder="Name eingeben... (optional)" />
			</div>
		</div>

		<div class="ten wide field">
			<div class="ui file input">
				<input type="file" name="measurement-document-${id}" id="measurement-document-${id}" accept=".jpg,.png,.webp">
			</div>

			<button type="button" class="ui red icon button" data-action="remove-file-input">
				<i class="times icon"></i>
			</button>
		</div>
	`
    container.append( file )
}

export function delete_measurement_file_input( target: HTMLElement ) {
    console.log( 'delete file input', target )

    const file = target.closest( '.measurement-document-fields' ) as HTMLElement
    file.remove()
}

export function clear_measurement_files_list() {
    jQuery( '.measurement-documents-list .files-list' ).html( '' )
}


export class Project_Measurement_Generator {
    constructor()  {
    }

    ready() {
        console.log( 'project measurement generator: ready' )
        this.init_tabs()
        this.init_actions()
        this.init_dropdowns()
        this.init_forms()
        this.init_events()
    }

    init_tabs() {
        jQuery( '#add-measurement-menu .item' ).tab()
    }

    init_actions() {
        jQuery( '[data-action="add-measurement"]' ).on( 'click', () => this.init_modal_add_measurement() )
    }

    init_dropdowns() {
        jQuery( '#add-measurement-staircase-type' ).dropdown()
    }

    init_events() {
        jQuery( '#form-add-measurement .measurement-documents-list' ).on(
            'click',
            ( e: ClickEvent ) => {
                console.log( 'clicked', e.target )

                const target = e.target as HTMLInputElement

                if ( target.dataset.action === 'add-file-input' ) {
                    this.add_measurement_file_input()
                    return
                }

                if ( target.dataset.action === 'remove-file-input' ) {
                    delete_measurement_file_input( target )
                    return
                }
            }
        )
    }

    init_forms() {
        jQuery( '#form-add-measurement' ).form(
            {
                fields: {
                    'add-measurement-staircase-type': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte einen Treppenart angeben.'
                            }
                        ]
                    },
                    'add-measurement-upper-floor-finish': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte Fußboden oben angeben.'
                            }
                        ]
                    },
                    'add-measurement-lower-floor-finish': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte Fußboden unten angeben.'
                            }
                        ]
                    },
                    'add-measurement-post-shape': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte Säulenform angeben.'
                            }
                        ]
                    },
                    'add-measurement-wall-handrail': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte Wandhandlauf angeben.'
                            }
                        ]
                    },
                    'add-measurement-top-step': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte Austrittsstufe angeben.'
                            }
                        ]
                    },
                    'add-measurement-led': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte LED angeben.'
                            }
                        ]
                    },
                },
                errorFocus: false,
                revalidate: true,
                onSuccess: ( e ) => this.add_measurement( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
            }
        )
    }

    add_measurement_file_input() {
        console.log( 'add measurement input' )

        const id: number = Date.now()

        const container = document.querySelector( '#form-add-measurement .files-list' ) as HTMLElement
        create_measurement_file_input( container, id )

        // Form Validation Fix für neue DOM Inputs
        jQuery( '#form-add-measurement-documents' ).form( 'set optional', `#measurement-document-titles[${id}]`, true )
    }

    init_modal_add_measurement() {
        console.log( 'init modal: add measurement documents' )

        const modal = app.get_modal( 'add-measurement' )
        const form   = jQuery( 'form', modal )

        // resets.
        form.form( 'reset' )
        clear_measurement_files_list()
        this.add_measurement_file_input()

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    add_measurement( e: Event ) {
        console.log( 'add measurement', e.currentTarget )

        // enable AJAX.
        e.preventDefault()

        const form = jQuery( '#form-add-measurement' ) as JQuery<HTMLFormElement>

        const submit = jQuery( '.submit', form )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( 'loading elastic' )

        const { ajax_url, nonce, post_id } = gt_ajax_object

        const data = new FormData( form[0] )
        data.append( 'action', 'add_measurement' )
        data.append( 'nonce', nonce )
        data.append( 'post-id', post_id ?? '' )

        console.debug( 'AJAX data', form.serialize() )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                data,
                cache: false,
                contentType: false,
                processData: false,
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response, submit )

                submit.removeAttr( 'disabled' )
                submit.removeClass( 'loading elastic' )

                if ( response.success === false ) {
                    app.show_toast_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        app.show_toast_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                if ( response.error ) {
                    app.show_toast_ajax_response( response.toast, 'error' )
                    return
                }

                if ( response.measurement ) {
                    app.show_toast_ajax_response( response.toast )
                    measurement = response.measurement
                    measurement_documents = response.attachments ?? []
                    project.get_meta( 'project-measurement-id' ).set_value( measurement.post_id )
                    project.update_properties_meta( response.properties )
                    project.measurement_controller = new Project_Measurement_Controller( measurement )
                    project.measurement_controller.ready()
                    project.measurement_generator = null
                    app.close_modals()
                }
            }
        )
    }
}

export class Project_Measurement_Controller extends Measurement_Controller {
    sheet_container: HTMLDivElement|null = null
    action_container: HTMLDivElement|null = null
    measurement: GT_Measurement|null = null
    meta: Measurement_Meta|null = null

    fields: Map<string, Measurement_Meta_Key> = new Map()
    translations: Map<string, string> = new Map()

    selected_index?: number = undefined
    documents: Measurement_Document[]

    constructor( measurement: GT_Measurement|null = null )  {
        super()
        this.measurement = measurement
        this.documents = measurement_documents

        if ( measurement ) {
            this.meta = measurement.meta
        }
    }

    ready() {
        if ( ! this.measurement ) {
            return
        }

        console.log( 'measurement ready' )

        this.set_action_container()
        this.set_sheet_container()
        this.init_actions()
        this.init_events()
        this.init_fields()
        this.init_checkboxes()
        this.init_forms()
        this.init_sliders()
        this.init_nags()
        this.render_measurement_sheet()
        this.render_measurement_preview()

        if ( this.measurement.revision_index === 0 ) {
            this.disable_logs_toggle()
        }
    }

    dismiss_nag() {
        jQuery( '#measurement-update' ).nag( 'dismiss' )
    }

    init_nags() {
        if ( project.get_meta_value( 'project-start-dates' ) && 'cutting' in project.get_meta_value( 'project-start-dates' ) && this.measurement && this.measurement.revision_index > 0 ) {
            const key = `project-${project.post_id}-measurement-revision-${this.measurement?.revision_index ?? 0}`

            console.log( 'nag key', key )

            this.render_nag_log_date()

            jQuery( '#measurement-update' )
                .nag(
                    {
                        persist: false,
                        key: key,
                        duration: 0,
                        expires: 0,
                        animation: {
                            show: 'fade',
                            hide: 'fade'
                        }
                    }
                )
        }
    }

    render_nag_log_date() {
        const index = this.measurement?.revision_index ?? 0

        if ( ! index ) {
            return
        }

        const log = this.find_audit_log_by_index( index )

        if ( ! log ) {
            return
        }

        const date = DateTime.fromSQL( log.date )
        jQuery( '#measurement-update .log-date' ).html( date.toFormat( 'D' ) )
    }

    init_fields() {
        this.fields.set( 'measurement-staircase-type', 'staircase_type' )
        this.fields.set( 'measurement-wood-type', 'wood_type' )
        this.fields.set( 'measurement-floor-to-floor-height', 'floor_to_floor_height' )
        this.fields.set( 'measurement-ceiling-height', 'ceiling_height' )
        this.fields.set( 'measurement-upper-floor-finish', 'upper_floor_finish' )
        this.fields.set( 'measurement-lower-floor-finish', 'lower_floor_finish' )
        this.fields.set( 'measurement-post-shape', 'post_shape' )
        this.fields.set( 'measurement-ceiling-lining-thickness', 'ceiling_lining_thickness' )
        this.fields.set( 'measurement-wall-handrail', 'wall_handrail' )
        this.fields.set( 'measurement-top-step', 'top_step' )
        this.fields.set( 'measurement-led', 'led' )
        this.fields.set( 'measurement-assembly-capacity', 'assembly_capacity' )
        this.fields.set( 'measurement-anti-slip-profile', 'anti_slip_profile' )
        this.fields.set( 'measurement-anti-slip-strip', 'anti_slip_strip' )
        this.fields.set( 'measurement-images', 'images' )

        this.fields.set( 'measurement-painted-finish', 'painted_finish' )
        this.fields.set( 'measurement-ral-color-finish', 'ral_color_finish' )
        this.fields.set( 'measurement-oiled-finish', 'oiled_finish' )
        this.fields.set( 'measurement-stained-finish', 'stained_finish' )
        this.fields.set( 'measurement-sanded-finish', 'sanded_finish' )
        this.fields.set( 'measurement-brushed-finish', 'brushed_finish' )
        this.fields.set( 'measurement-sample-request', 'sample_request' )

        this.fields.set( 'measurement-building-code-clearance-strip', 'building_code_clearance_strip' )
        this.fields.set( 'measurement-work-platform', 'work_platform' )
        this.fields.set( 'measurement-construction-materials', 'construction_materials' )
        this.fields.set( 'measurement-packing-timber', 'packing_timber' )
        this.fields.set( 'measurement-dismantling', 'dismantling' )
        this.fields.set( 'measurement-logistics', 'logistics' )
        this.fields.set( 'measurement-trailer', 'trailer' )
        this.fields.set( 'measurement-stair-protection', 'stair_protection' )
        this.fields.set( 'measurement-stair-hardware', 'stair_hardware' )

        this.fields.set( 'measurement-special-conditions', 'special_conditions' )
        this.fields.set( 'measurement-wall-materials', 'wall_materials' )
        this.fields.set( 'measurement-custom-request', 'custom_request' )
        this.fields.set( 'measurement-heating', 'heating' )
        this.fields.set( 'measurement-electrical', 'electrical' )

        this.fields.set( 'measurement-construction-notes', 'construction_notes' )

        this.translations.set( 'measurement_staircase_type', 'Treppenart' )
        this.translations.set( 'measurement_wood_type', 'Holzart' )
        this.translations.set( 'measurement_floor_to_floor_height', 'Geschosshöhe' )
        this.translations.set( 'measurement_ceiling_height', 'Raumhöhe' )
        this.translations.set( 'measurement_upper_floor_finish', 'Fußboden oben' )
        this.translations.set( 'measurement_lower_floor_finish', 'Fußboden unten' )
        this.translations.set( 'measurement_post_shape', 'Säulenform' )
        this.translations.set( 'measurement_ceiling_lining_thickness', 'Dvklg / Dicke' )
        this.translations.set( 'measurement_wall_handrail', 'Wandhandlauf' )
        this.translations.set( 'measurement_top_step', 'Austrittsstufe' )
        this.translations.set( 'measurement_led', 'LED' )
        this.translations.set( 'measurement_assembly_capacity', 'Montagekapazität' )
        this.translations.set( 'measurement_anti_slip_profile', 'Antirutsch Profil' )
        this.translations.set( 'measurement_anti_slip_strip', 'Antirutsch Streifen' )
        this.translations.set( 'measurement_images', 'Bilder' )

        this.translations.set( 'measurement_painted_finish', 'Lack' )
        this.translations.set( 'measurement_ral_color_finish', 'RAL' )
        this.translations.set( 'measurement_oiled_finish', 'Öl' )
        this.translations.set( 'measurement_stained_finish', 'Beize' )
        this.translations.set( 'measurement_sanded_finish', 'geschliffen' )
        this.translations.set( 'measurement_brushed_finish', 'gebürstet' )
        this.translations.set( 'measurement_sample_request', 'Musterwunsch' )

        this.translations.set( 'measurement_building_code_clearance_strip', 'Baurechtsleiste' )
        this.translations.set( 'measurement_work_platform', 'Gerüst' )
        this.translations.set( 'measurement_construction_materials', 'Baumaterial' )
        this.translations.set( 'measurement_packing_timber', 'Futterholz' )
        this.translations.set( 'measurement_dismantling', 'Demontage' )
        this.translations.set( 'measurement_logistics', 'Logistik' )
        this.translations.set( 'measurement_trailer', 'Anhänger' )
        this.translations.set( 'measurement_stair_protection', 'Treppenschutz' )
        this.translations.set( 'measurement_stair_hardware', 'Beschläge' )

        this.translations.set( 'measurement_special_conditions', 'Besonderheiten' )
        this.translations.set( 'measurement_wall_materials', 'Wandmaterial' )
        this.translations.set( 'measurement_custom_request', 'Spezialwunsch' )
        this.translations.set( 'measurement_heating', 'Heizung' )
        this.translations.set( 'measurement_electrical', 'Elektro' )

        this.translations.set( 'measurement_construction-notes', 'Hinweise' )
    }

    destroy_sliders() {
        jQuery( '.measurement-audit-logs .slider' ).slider( 'destroy' )
    }

    init_sliders() {
        jQuery( '.measurement-audit-logs .slider' ).slider(
            {
                min: 1,
                max: this.measurement?.revision_index,
                start: this.measurement?.revision_index,

                restrictedLabels: this.generate_slider_labels(),
                autoAdjustLabels: false,
                showLabelTicks: 'always',

                showThumbTooltip: true,
                tooltipConfig: {
                    position: 'bottom center',
                    variation: 'small visible black'
                },

                onChange: function( value: number ) {
                    console.log( 'change value', value )
                },
                onMove: function( value: number ) {
                    console.log( 'move value', value )

                    project.measurement_controller.render_audit_log( value )
                }
            }
        )
    }

    enable_logs_toggle() {
        jQuery( '#measurement-sheet-audit-logs-toggle' ).parent().checkbox( 'set enabled' )
    }

    disable_logs_toggle() {
        jQuery( '#measurement-sheet-audit-logs-toggle' ).parent().checkbox( 'set disabled' )
    }

    generate_slider_labels() {
        const result = [ 1 ]
        const length = this.measurement?.audit_logs.length

        if ( ! length ) {
            return result
        }

        // 10er-Schritte hinzufügen
        for ( let i = 10; i <= length; i += 10 ) {
            result.push( i )
        }

        // letzte Zahl ergänzen, wenn nötig
        if ( length > 1 && length % 10 !== 0 ) {
            result.push( length )
        }

        console.log( 'slider labels', result )

        return result
    }

    init_checkboxes() {
        jQuery( '#form-update-measurement-sheet .sheet-field-form-control .checkbox' ).checkbox(
            {

                // @ts-expect-error Overload
                onChange: function( this: HTMLInputElement ) {
                    const field: HTMLElement|null = this.closest( '[data-field]' )

                    if ( ! field ) {
                        return
                    }

                    const field_key: string = field.dataset.field ?? ''

                    const checkbox: HTMLElement = this.closest( '.ui.checkbox' )!
                    const is_checked: boolean = jQuery( checkbox ).checkbox( 'is checked' )

                    const changed = project.measurement_controller.check_toggle_value_change( field_key, is_checked )

                    console.log( 'onchange', is_checked, changed )

                    const button = field.querySelector( '.sheet-field-actions button' )!

                    if ( changed ) {
                        button.classList.remove( 'disabled' )
                        button.classList.add( 'primary' )
                    } else {
                        button.classList.add( 'disabled' )
                        button.classList.remove( 'primary' )
                    }
                }
            }
        )

        jQuery( '#measurement-sheet-update-toggle' ).checkbox(
            {
                onChange: function() {
                    const sheet: HTMLElement|null = document.querySelector( '#form-update-measurement-sheet' )

                    if ( ! sheet ) {
                        return
                    }

                    sheet.dataset.updateMode = sheet.dataset.updateMode === 'true' ? 'false' : 'true'
                }
            }
        )

        const logs_toggle = jQuery( '#measurement-sheet-audit-logs-toggle' )
        logs_toggle.checkbox(
            {
                onChange: function() {
                    const container = document.querySelector( '.measurement-audit-logs' )

                    if ( ! container ) {
                        return
                    }

                    const is_checked = logs_toggle.closest( '.checkbox' ).checkbox( 'is checked' )

                    if ( is_checked ) {
                        container.classList.add( 'is-visible' )
                    } else {
                        container.classList.remove( 'is-visible' )
                    }
                }
            }
        )
    }

    init_actions() {
        jQuery( '[data-action="show-measurement"]' ).on( 'click', () => this.init_modal_measurement() )
        jQuery( '[data-action="update-measurement-meta"]' ).on( 'click', ( e: ClickEvent ): void => this.update_measurement_meta( e.target ) )
        jQuery( '[data-action="show-measurement-meta-log"]' ).on( 'click', ( e: ClickEvent ): void => this.show_measurement_meta_log( e.target ) )
        jQuery( '[data-action="next-audit-log"]' ).on( 'click', () => this.next_audit_log() )
        jQuery( '[data-action="prev-audit-log"]' ).on( 'click', () => this.prev_audit_log() )
        jQuery( '[data-action="close-measurement"]' ).on( 'click', () => app.close_modals() )
        jQuery( '[data-action="add-measurement-documents"]' ).on( 'click', () => this.init_modal_add_documents() )
    }

    next_audit_log() {
        if ( ! this.selected_index ) {
            return
        }

        this.selected_index += 1
        this.update_index()

        this.render_audit_log( this.selected_index )

        const slider = jQuery( '.revision-controls .slider' )
        slider.slider( 'set value', this.selected_index, false )
    }

    prev_audit_log() {
        if ( ! this.selected_index ) {
            return
        }

        this.selected_index -= 1
        this.update_index()

        this.render_audit_log( this.selected_index )

        const slider = jQuery( '.revision-controls .slider' )
        slider.slider( 'set value', this.selected_index, false )
    }

    init_modal_measurement() {
        console.log( 'INIT MODAL', measurement.meta )
        const modal = app.get_modal( 'measurement-sheet' )
        modal.modal(
            {
                autofocus: true,
                observeChanges: false
            }
        )
        modal.modal( 'show' )
    }

    init_modal_measurement_preview() {
        const modal = app.get_modal( 'measurement-sheet-preview' )

        if ( ! modal ) {
            return
        }

        modal.modal( 'show' )
    }

    show_measurement_meta_log( target: HTMLElement ) {
        console.log( 'meta log', target )

        const field: HTMLElement|null = target.closest(  '[data-field]' )

        if ( ! field ) {
            return
        }

        const field_key: Measurement_Meta_Key = field.dataset.field as Measurement_Meta_Key

        if ( ! field_key ) {
            return
        }

        this.render_field_audit_logs( field_key )

        const modal = app.get_modal( 'measurement-meta-log' )
        modal.modal(
            {
                autofocus: true,
                observeChanges: false,
                onHidden: () => {
                    const modal = app.get_modal( 'measurement-sheet' )
                    modal.modal( 'show' )
                }
            }
        )
        modal.modal( 'show' )
    }

    render_audit_log( index: number ) {
        this.selected_index = index
        this.update_index()

        const log = this.find_audit_log_by_index( index )

        if ( ! log ) {
            return
        }

        const container: HTMLElement|null = document.querySelector( '.measurement-audit-logs' )

        if ( ! container ) {
            return
        }

        const audit_log = container.querySelector( '.audit-log' )!

        let before = log.before
        let after  = log.after

        if ( before === '' || before === false ) {
            before = '<i class="red times icon"></i>'
        }

        if ( after === '' || after === false ) {
            after = '<i class="red times icon"></i>'
        }

        if ( before === true ) {
            before = '<i class="green checkmark icon"></i>'
        }

        if ( after === true ) {
            after = '<i class="green checkmark icon"></i>'
        }

        audit_log.innerHTML = `   
            <div class="badge">${ this.translations.get( log.field ) }</div>
          
            <div class="log-meta log-date">
                <i class="calendar alternate outline icon"></i> 
                <span>${ format_date( log.date ) } - ${ format_time( log.date ) } Uhr</span>   
            </div>
                
            <div class="log-meta log-user">
                <i class="user icon"></i> ${ log.author.name }
            </div>
            
            <div class="diff">
                <div class="diff-before">
                    <span>${ before }</span>
                </div>
                <div class="diff-arrow"><i class="angle double right icon"></i></div>
                <div class="diff-after">
                    <span>${ after }</span>
                </div>
            </div>
        `
    }

    update_index() {
        const selected_index: HTMLElement|null = document.querySelector( '.selected-index' )

        if ( ! selected_index || ! this.selected_index || ! this.measurement ) {
            return
        }

        console.log( 'update index', selected_index, this.selected_index, this.measurement.audit_logs.length )

        selected_index.innerText = this.selected_index.toString()

        const prev_button = document.querySelector( '[data-action="prev-audit-log"]' ) as HTMLElement
        const next_button = document.querySelector( '[data-action="next-audit-log"]' ) as HTMLElement

        if ( this.selected_index < this.measurement.audit_logs.length + 1 ) {
            next_button.classList.remove( 'disabled' )
        } else {
            next_button.classList.add( 'disabled' )
        }

        if ( this.selected_index > 1 ) {
            this.enable_logs_toggle()
            prev_button.classList.remove( 'disabled' )
        } else {
            prev_button.classList.add( 'disabled' )
        }
    }

    render_field_audit_logs( field_key: Measurement_Meta_Key ) {
        const key = this.fields.get( field_key ) as keyof Measurement_Meta

        const logs: Measurement_Audit_Log[] = this.find_audit_logs_by_key( key )
        console.log( 'logs', logs )

        const container: HTMLElement = document.querySelector( '.audit-logs' )!
        container.innerHTML = ''

        for ( const log of logs.toReversed() ) {
            container.append( this.create_field_audit_log( log ) )
        }
    }

    create_field_audit_log( log: Measurement_Audit_Log ) {
        const container: HTMLDivElement = document.createElement( 'div' )
        container.classList.add( 'audit-log' )

        let before = log.before
        let after  = log.after

        if ( before === '' || before === false ) {
            before = '<i class="red times icon"></i>'
        }

        if ( after === '' || after === false ) {
            after = '<i class="red times icon"></i>'
        }

        if ( before === true ) {
            before = '<i class="green checkmark icon"></i>'
        }

        if ( after === true ) {
            after = '<i class="green checkmark icon"></i>'
        }

        container.innerHTML = `
            <div class="badge">Änderung ${ log.revision }</div>
            
            <div class="log-meta log-date">
                <i class="calendar alternate outline icon"></i> 
                <span>${ format_date( log.date ) } - ${ format_time( log.date ) } Uhr</span>   
            </div>
                
            <div class="log-meta log-user">
                <i class="user icon"></i> ${ log.author.name }
            </div>
            
            <div class="diff">
                <div class="diff-before">
                    <span>${ before }</span>
                </div>
                <div class="diff-arrow"><i class="angle double right icon"></i></div>
                <div class="diff-after">
                    <span>${ after }</span>
                </div>
            </div>
        `
        return container
    }

    disable_reset_buttons() {
        const buttons = this.sheet_container!.querySelectorAll( '[data-action="update-measurement-meta"]' )

        for ( const button of Array.from( buttons ) ) {
            button.classList.add( 'disabled' )
            button.classList.remove( 'primary' )
        }
    }

    update_measurement_meta( target: HTMLElement )  {
        const field: HTMLElement|null = target.closest(  '[data-field]' )

        if ( ! field ) {
            return
        }

        const field_key: Measurement_Meta_Key = field.dataset.field as Measurement_Meta_Key
        const field_type: string|undefined = field.dataset.fieldType

        if ( ! field_key || ! field_type ) {
            return
        }

        const valid = jQuery( '#form-update-measurement-sheet' ).form( 'validate field', field_key )

        console.log( 'update field', target, field_key, valid )

        this.disable_reset_buttons()
        target.classList.add( 'loading' )

        const action = 'update_measurement_meta'

        let meta_value = null
        const meta_key = this.fields.get( field_key )

        switch ( field_type ) {
            case 'input-text':
            case 'input-number': {
                const input = field.querySelector( 'input' )!
                meta_value = input?.value
                break
            }
            case 'textarea': {
                const textarea = field.querySelector( 'textarea' )
                meta_value = textarea?.value
                break
            }
            case 'toggle': {
                const toggle = field.querySelector( '.ui.toggle' )!
                meta_value = jQuery( toggle ).checkbox( 'is checked' )
                break
            }
        }

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action,
            meta_key,
            meta_value,
            field_type,
            nonce,
            post_id: project.get_meta_value( 'project-measurement-id' )
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false,
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                target.classList.remove( 'loading' )

                this.measurement = response.measurement
                this.meta = response.measurement.meta
                this.render_measurement_sheet()
                this.init_nags()
                this.dismiss_nag()
            }
        )
    }

    init_events() {
        jQuery( '#form-update-measurement-sheet input:is([type="text"],[type="number"])' ).on(
            'input',
            ( e ): void => {
                const target = e.target as HTMLInputElement
                const field: HTMLElement|null = target.closest( '[data-field]' )

                if ( ! field ) {
                    return
                }

                const field_key: string = field.dataset.field ?? ''

                const changed = this.check_input_value_change( field_key, target.value )
                console.log( 'CHANGE', target, changed )

                const button = field.querySelector( '.sheet-field-actions button' )!

                if ( changed ) {
                    button.classList.remove( 'disabled' )
                    button.classList.add( 'primary' )
                } else {
                    button.classList.add( 'disabled' )
                    button.classList.remove( 'primary' )
                }

                jQuery( '#form-update-measurement-sheet' ).form( 'validate field', field_key )
            }
        )

        jQuery( '#form-update-measurement-sheet  textarea' ).on(
            'input',
            ( e ): void => {
                const target = e.target as HTMLInputElement
                const field: HTMLElement|null = target.closest( '[data-field]' )

                if ( ! field ) {
                    return
                }

                const field_key: string = field.dataset.field ?? ''

                const changed = this.check_textarea_value_change( field_key, target.value )
                console.log( 'CHANGE', target, changed )

                const button = field.querySelector( '.sheet-field-actions button' )!

                if ( changed ) {
                    button.classList.remove( 'disabled' )
                    button.classList.add( 'primary' )
                } else {
                    button.classList.add( 'disabled' )
                    button.classList.remove( 'primary' )
                }

                jQuery( '#form-update-measurement-sheet' ).form( 'validate field', field_key )
            }
        )

        jQuery( '.construction-images .image-list' ).on(
            'click',
            ( e ) => {
                const target = e.target.closest( '.list-item' ) as HTMLElement

                if ( target == null ) {
                    return
                }

                if ( 'debug' in e.target.dataset ) {
                    return
                }

                if ( e.target.dataset.action === 'update-measurement-document' ) {
                    this.init_modal_update_document( target )
                    return
                }

                if ( e.target.dataset.action === 'delete-measurement-document' ) {
                    this.delete_document_confirmation( target )
                    return
                }
            }
        )

        jQuery( '#form-add-measurement-documents .measurement-documents-list' ).on(
            'click',
            ( e: ClickEvent ) => {
                console.log( 'clicked', e.target )

                const target = e.target as HTMLInputElement

                if ( target.dataset.action === 'add-file-input' ) {
                    this.add_document_file_input()
                    return
                }

                if ( target.dataset.action === 'remove-file-input' ) {
                    delete_measurement_file_input( target )
                    return
                }
            }
        )

        jQuery( '[data-action="show-measurement-preview"]' ).on( 'click', () => this.init_modal_measurement_preview() )
    }

    delete_document_confirmation( item: HTMLElement ) {
        const attachment_id: string|undefined = item.dataset.postId
        console.log( 'delete measurement document?', attachment_id )

        if ( ! attachment_id ) {
            return
        }

        const confirmation = app.get_modal( 'delete-measurement-document-confirmation' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved' )
                    this.delete_document( attachment_id )
                }
            }
        )
        confirmation.modal( 'show' )
    }

    delete_document( attachment_id: string ) {
        console.log( 'delete measurement document', attachment_id )

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_measurement_document',
            post_id,
            attachment_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.success === false ) {
                    app.show_toast_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        app.show_toast_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                app.show_toast_ajax_response( response.toast )

                this.documents = response.attachments ?? []
                this.render_measurement_sheet()
                const modal = app.get_modal( 'measurement-sheet' )
                modal.modal( 'show' )
            }
        )
    }

    init_modal_add_documents() {
        console.log( 'init modal: add measurement documents' )

        const modal = app.get_modal( 'add-measurement-documents' )
        const form   = jQuery( 'form', modal )

        // resets.
        form.form( 'reset' )
        clear_measurement_files_list()
        this.add_document_file_input()

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    add_document_file_input() {
        console.log( 'add measurement document input' )

        const id: number = Date.now()

        const container = document.querySelector( '#form-add-measurement-documents .files-list' ) as HTMLElement
        create_measurement_file_input( container, id )

        // Form Validation Fix für neue DOM Inputs
        jQuery( '#form-add-measurement-documents' ).form( 'set optional', `#measurement-document-titles[${id}]`, true )
    }

    add_documents( e: Event ) {
        console.log( 'add measurement documents', e )

        // enable AJAX.
        e.preventDefault()

        const form = jQuery( '#form-add-measurement-documents' ) as JQuery<HTMLFormElement>

        const submit = jQuery( '.submit', form )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( 'loading' )

        const { ajax_url, post_id, nonce } = gt_ajax_object

        const data = new FormData( form[0] )
        data.append( 'action', 'add_measurement_documents' )
        data.append( 'nonce', nonce )
        data.append( 'post_id', post_id ?? '' )

        console.debug( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                data,
                cache: false,
                contentType: false,
                processData: false,
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.error ) {
                    app.show_toast_ajax_response( response.toast, 'error' )
                    return
                }

                if ( response.count ) {
                    app.show_toast_ajax_response( response.toast )
                } else {
                    app.show_toast_ajax_response( response.toast, '', 'info' )
                }

                submit.removeAttr( 'disabled' )
                submit.removeClass( 'loading' )

                this.documents = response.attachments ?? []
                this.render_measurement_sheet()
                const modal = app.get_modal( 'measurement-sheet' )
                modal.modal( 'show' )
            }
        )
    }

    init_modal_update_document( item: HTMLElement ) {
        const post_id = Number( item.dataset.postId )
        const post: Measurement_Document|undefined = this.documents.find( el => el.post_id === post_id )
        console.debug( 'update measurement document', post_id, post )

        if ( ! post ) {
            return
        }

        const modal = app.get_modal( 'update-measurement-document' )
        const title = jQuery( '#measurement-document-title-edit' )

        const form = jQuery( '#form-update-measurement-document' )

        // resets.
        form.form( 'reset' )

        // sets.
        title.val( post.title )
        modal.find( '[name="post-id"]' ).val( post_id )

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    update_document( e: Event ) {
        console.debug( 'update measurement document', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const form      = jQuery( '#form-update-measurement-document' )
        const form_data = form.serialize()

        const form_buttons  = jQuery( '.form-actions button', form )
        const submit_button = jQuery( '.submit', form )
        form_buttons.attr( 'disabled', 'disabled' )
        submit_button.addClass( 'loading elastic' )

        const { nonce, post_id, ajax_url } = gt_ajax_object

        const data = {
            action: 'update_measurement_document',
            post_id,
            form_data,
            nonce
        }

        console.debug( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                form_buttons.removeAttr( 'disabled' )
                submit_button.removeClass( 'loading elastic' )

                if ( response.success === false ) {
                    app.show_toast_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        app.show_toast_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                if ( response.error ) {
                    app.show_toast_ajax_response( response.toast, 'error' )
                    return
                }

                app.show_toast_ajax_response( response.toast )

                const index = this.documents.findIndex( el => el.post_id === Number( response.attachment?.ID ) )
                this.documents[index].title = response.attachment?.post_title

                this.render_measurement_sheet()
                const modal = app.get_modal( 'measurement-sheet' )
                modal.modal( 'show' )
            }
        )
    }

    init_forms() {
        jQuery( '#form-update-measurement-sheet' ).form(
            {
                fields: {
                    'measurement-staircase-type': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Treppenart angeben.'
                            }
                        ]
                    },
                    'measurement-floor-to-floor-height': {
                        optional: true,
                        rules: [
                            {
                                type: 'number',
                                prompt: 'Bitte eine Zahlenangabe für die Geschosshöhe angeben.'
                            }
                        ]
                    },
                    'measurement-ceiling-height': {
                        optional: true,
                        rules: [
                            {
                                type: 'number',
                                prompt: 'Bitte eine Zahlenangabe für die Raumhöhe angeben.'
                            }
                        ]
                    }
                },
                errorFocus: false,
                revalidate: true,
                onSuccess: ( e ) => e.preventDefault(),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
            }
        )

        jQuery( '#form-add-measurement-documents' ).form(
            {
                errorFocus: false,
                onSuccess: ( e ) => this.add_documents( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
            }
        )

        jQuery( '#form-update-measurement-document' ).form(
            {
                fields: {
                    'measurement-document-title-edit': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte einen Titel angeben.'
                            }
                        ]
                    }
                },
                errorFocus: false,
                revalidate: true,
                onSuccess: ( e ) => this.update_document( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
            }
        )
    }

    set_action_container() {
        this.action_container = document.querySelector( '.action-container[data-post-type="measurement"]' ) as HTMLDivElement

        if ( ! this.action_container ) {
            return
        }

        this.action_container.dataset.created = 'true'

        const span = this.action_container.querySelector( '.no-posts span' ) as HTMLElement
        span.innerHTML = 'noch keine Skizzen vorhanden'
    }

    get_action_container() {
        if ( ! this.action_container ) {
            throw new Error ( 'kein Action Container' )
        }

        return this.action_container
    }

    set_sheet_container() {
        this.sheet_container = document.querySelector( '.measurement-sheet' )
    }

    check_input_value_change( field_key: string, new_value: string ): boolean {
        if ( ! this.meta ) {
            return false
        }

        const meta_key: string|undefined = this.fields.get( field_key )

        if ( ! meta_key ) {
            return false
        }

        const old_value: string = this.meta[meta_key as keyof Measurement_Meta] as string

        console.log( old_value, new_value )

        return old_value != new_value
    }

    check_textarea_value_change( field_key: string, new_value: string ): boolean {
        if ( ! this.meta ) {
            return false
        }

        const meta_key: string|undefined = this.fields.get( field_key )

        if ( ! meta_key ) {
            return false
        }

        const old_value: string = this.meta[meta_key as keyof Measurement_Meta] as string ?? ''

        const normalize = ( v: string ) =>
            v.replace( /\r\n/g, '\n' ).trim()

        console.log( 'old', JSON.stringify( normalize( old_value ) ) )
        console.log( 'new', JSON.stringify( normalize( new_value ) ) )
        console.log( '!=', normalize( old_value ) !== normalize( new_value ) )

        return normalize( old_value ) !== normalize( new_value )
    }

    check_toggle_value_change( field_key: string, new_value: boolean ): boolean {
        if ( ! this.meta ) {
            return false
        }

        const meta_key: string|undefined = this.fields.get( field_key )

        if ( ! meta_key ) {
            return false
        }

        const old_value: boolean = this.meta[meta_key as keyof Measurement_Meta] as boolean

        // console.log( old_value, new_value )

        return old_value != new_value
    }

    render_measurement_sheet() {
        if ( ! this.measurement || ! this.sheet_container ) {
            return
        }

        this.render_last_change()

        for ( const [ key, value ] of this.fields ) {
            this.render_field( key, value )
        }

        this.render_documents()

        this.destroy_sliders()
        this.init_sliders()
        if ( this.measurement.revision_index > 0 ) {
            this.enable_logs_toggle()
        }
        this.selected_index = this.measurement.revision_index
        this.update_index()
        this.render_audit_log( this.selected_index )
    }

    render_measurement_preview() {
        if ( ! this.measurement || ! this.sheet_container ) {
            return
        }

        for ( const [ key, value ] of this.fields ) {
            this.render_preview_field( key, value )
        }
    }

    render_documents() {
        console.log( 'render measurement documents', this.documents.length )

        if ( ! this.sheet_container ) {
            return
        }

        const items    = this.documents
        const sheet_list  = this.sheet_container.querySelector( '.image-list' ) as HTMLElement
        sheet_list.innerHTML  = ''

        const container_list = this.get_action_container().querySelector( '.item-list' ) as HTMLElement
        container_list.innerHTML = ''

        console.debug( 'all measurement documents', this.documents )

        if ( items.length > 0 ) {
            for ( const item of items.toReversed() ) {
                const li = document.createElement( 'li' )

                li.classList.add( 'list-item', 'attachment-item', 'collapsed' )
                li.dataset.category = 'measurement-document'
                li.dataset.postId   = item.post_id.toString()
                li.dataset.type     = item.type

                li.innerHTML = `
                <div class="item-title">	
                    <div class="title">${item.title}</div>
                
                    <div class="details">
                        <span>
                            <i class="file icon"></i> ${item.extension.ext.toUpperCase()}
                        </span>

                        <span>
                            <i class="download icon"></i> ${item.filesize.human}
                        </span>

                        <span>
                            <i class="calendar alternate outline icon"></i> ${format_date( item.date )}
                        </span>
                    </div>
                    
                </div>
                
                <div class="item-info">
                    <a href="${item.permalink}" class="ui basic blue icon button" target="_blank">
                        <i class="download icon"></i> Download
                    </a>
                </div>
                
                <div class="item-actions">
                    <a class="ui tiny primary button debug" href="/wp-admin/post.php?post=${item.post_id}&action=edit" 
                    target="_blank" data-debug data-hidden="${( gt_user_settings.enable_debug === '1' ? 'false' : 'true' )}">Post bearbeiten</a>

                    <button type="button" class="ui small compact button" data-action="update-measurement-document">bearbeiten</button>
                    <button type="button" class="ui small compact red delete button" data-action="delete-measurement-document">löschen</button>
                </div>
                `

                sheet_list.append( li )
            }

            for ( const item of items.toReversed() ) {
                const li = document.createElement( 'li' )

                li.classList.add( 'list-item', 'attachment-item', 'collapsed' )
                li.dataset.category = 'measurement-document'
                li.dataset.postId   = item.post_id.toString()
                li.dataset.type     = item.type

                li.innerHTML = `
                <div class="item-title">	
                    <div class="title">${item.title}</div>                   
                </div>
                
                <div class="item-info">
                    <a href="${item.permalink}" class="ui basic blue icon button" target="_blank">
                        <i class="download icon"></i>
                    </a>
                </div>
                `

                container_list.append( li )
            }
        }
    }

    render_last_change() {
        const logs: Measurement_Audit_Log[] = this.measurement!.audit_logs

        const log_date = this.get_action_container().querySelector( '.count' ) as HTMLElement

        console.log( 'render log date', logs, log_date )

        if ( ! logs.length ) {
            const date = DateTime.fromSQL( measurement.post_date )
            log_date.innerHTML = date.toFormat( 'D' )
            return
        }

        const last_log: Measurement_Audit_Log = logs[logs.length - 1]
        const date = DateTime.fromSQL( last_log.date )
        log_date.innerHTML = date.toFormat( 'D' )
    }

    render_field( field: string, key: string = '' ) {
        if ( ! this.measurement || ! this.sheet_container || key === '' ) {
            return
        }

        // console.log( 'rendering measurement sheet', key )

        const container: HTMLElement|null = this.sheet_container.querySelector( `[data-field="${field}"]` )

        if ( ! container ) {
            return;
        }

        const logs: Measurement_Audit_Log[] = this.find_audit_logs_by_key( key )

        this.render_field_value( container, key )

        if ( ! container.dataset.fieldType ) {
            return
        }

        this.render_field_form_control( container, key )
        this.render_field_date( container, logs )
        this.render_field_user( container, logs )
        this.render_field_revision_count( container, logs )
    }

    render_preview_field( field: string, key: string = '' ) {
        if ( ! this.measurement || ! this.sheet_container || key === '' ) {
            return
        }

        const container: HTMLElement|null = document.querySelector( `.measurement-sheet-preview-content [data-field="${field}"]` )

        if ( ! container ) {
            return;
        }

        this.render_field_value( container, key )
    }

    render_field_revision_count( container: HTMLElement, logs: Measurement_Audit_Log[] ) {
        if ( ! this.meta ) {
            return
        }

        logs.reverse()

        // console.log( 'render revision count', logs )

        const button: HTMLElement = container.querySelector( '.sheet-field-revision-count button' ) as HTMLElement

        const element: HTMLElement = button.querySelector( 'span' ) as HTMLElement

        if ( logs.length ) {
            button.classList.remove( 'disabled' )
            element.innerHTML = logs[0].revision.toString()
        } else {
            button.classList.add( 'disabled' )
            element.innerHTML = '0'
        }

    }

    render_field_value( container: HTMLElement, key: string ): void {
        container.classList.remove( 'empty' )
        if ( ! this.meta ) {
            return
        }

        const element: HTMLElement = container.querySelector( '.sheet-field-value' )!

        switch ( key ) {

            // Texts
            case 'staircase_type':
            case 'wood_type':
            case 'upper_floor_finish':
            case 'lower_floor_finish':
            case 'post_shape':
            case 'wall_handrail':
            case 'top_step':
            case 'led':
            case 'painted_finish':
            case 'ral_color_finish':
            case 'oiled_finish':
            case 'stained_finish':
            case 'sample_request':
            case 'building_code_clearance_strip':
            case 'work_platform':
            case 'construction_materials':
            case 'packing_timber':
            case 'dismantling':
            case 'logistics':
            case 'trailer':
            case 'stair_protection':
            case 'stair_hardware':
            case 'special_conditions':
            case 'wall_materials':
            case 'custom_request':
            case 'heating':
            case 'electrical':
            case 'assembly_capacity':
            case 'construction_notes':
                element.innerHTML = this.meta[key] ?? ''
                break

            // Numbers
            case 'floor_to_floor_height':
            case 'ceiling_height':
            case 'ceiling_lining_thickness':
            {
                const value = this.meta[key]
                element.innerHTML = value ? `${value.toLocaleString( 'de-DE', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                } )} mm` : ''
                break
            }

            // Booleans / Toggles
            case 'anti_slip_profile':
            case 'anti_slip_strip':
            case 'images':
            case 'sanded_finish':
            case 'brushed_finish':
                element.innerHTML = this.meta[key] ? '<i class="green check icon"></i>' : '<i class="red times icon"></i>'
                break

            default:
                element.innerHTML = ''
        }

        if ( element.innerHTML === '' || element.innerHTML === '<i class="red times icon"></i>' ) {
            container.classList.add( 'empty' )
        }
    }

    render_field_form_control( container: HTMLElement, key: string ): void {
        if ( ! this.meta ) {
            return
        }

        const element: HTMLElement = container.querySelector( '.form-control' )!

        switch ( key ) {

            // Input Text, Input Number
            case 'staircase_type':
            case 'wood_type':
            case 'assembly_capacity':
            case 'floor_to_floor_height':
            case 'ceiling_height':
            case 'upper_floor_finish':
            case 'lower_floor_finish':
            case 'post_shape':
            case 'ceiling_lining_thickness':
            case 'wall_handrail':
            case 'top_step':
            case 'led':
            case 'painted_finish':
            case 'ral_color_finish':
            case 'oiled_finish':
            case 'stained_finish':
            case 'sample_request':
            case 'building_code_clearance_strip':
            case 'work_platform':
            case 'construction_materials':
            case 'packing_timber':
            case 'dismantling':
            case 'logistics':
            case 'trailer':
            case 'stair_protection':
            case 'stair_hardware':
            case 'wall_materials':
            case 'custom_request':
            case 'heating':
            case 'electrical':
                if ( 'value' in element ) {
                    element.value = this.meta[key] ?? ''
                }
                break

            // Textarea
            case 'special_conditions':
            case 'construction_notes':
                element.innerHTML = this.meta[key] ?? ''
                break

            // Checkbox Toggle
            case 'anti_slip_profile':
            case 'anti_slip_strip':
            case 'images':
            case 'sanded_finish':
            case 'brushed_finish':
                if ( this.meta[key] ) {
                    jQuery( element ).checkbox( 'check' )
                } else {
                    jQuery( element ).checkbox( 'uncheck' )
                }
                break;
        }
    }

    render_field_date( field: HTMLElement, logs: Measurement_Audit_Log[] ) {
        const element: HTMLElement = field.querySelector( '.sheet-field-date' )!

        if ( logs.length ) {
            const log: Measurement_Audit_Log = logs.at( -1 ) as Measurement_Audit_Log

            element.innerHTML = `
                <i class="calendar alternate outline icon"></i>
                ${format_date( log.date )}
            `
        } else {
            element.innerHTML = `
                <i class="calendar alternate outline icon"></i>
                ${format_date( this.measurement?.post_date )}
            `
        }
    }

    render_field_user( field: HTMLElement, logs: Measurement_Audit_Log[] ) {
        const element: HTMLElement = field.querySelector( '.sheet-field-user' )!

        if ( logs.length ) {
            const log: Measurement_Audit_Log = logs.at( -1 ) as Measurement_Audit_Log

            element.innerHTML = `
                <i class="user icon"></i>
                ${log.author.name}
            `
        } else {
            element.innerHTML = `
                <i class="user icon"></i>
                ${this.measurement?.author.name}
            `
        }
    }

    find_audit_log_by_index( index: number ): Measurement_Audit_Log|undefined {
        const logs: Measurement_Audit_Log[] = this.measurement!.audit_logs

        // console.log( 'find log', index, logs )

        return logs.find( ( el: Measurement_Audit_Log ): boolean => Number( el.revision ) === index )
    }

    find_audit_logs_by_key( key: string ): Measurement_Audit_Log[] {
        const logs: Measurement_Audit_Log[] = this.measurement!.audit_logs

        // console.log( 'find log', key, logs )

        return logs.filter( ( el: Measurement_Audit_Log ): boolean => el.field === `measurement_${key}` )
    }
}
